import React, { ReactNode, useMemo } from 'react';
import { Loader } from 'ui-library';
import './LoadingOverlap.css';

interface ILoadingOverlap {
    isLoading?: boolean;
    children?: ReactNode;
}

export const LoadingOverlap = ({
    isLoading = false,
    children = null,
} : ILoadingOverlap) => {
    const className = useMemo(() => (isLoading ? 'loading-overlap' : undefined), [isLoading]);

    return (
        <div className={className}>
            {children}
            {isLoading && <div className="overlap-loader"><Loader/></div>}
        </div>
    );
};
